export default function Loader({ text = "Loading ..." }) {
  return (
    <div className="relative overflow-hidden">
      <div
        style={{ backgroundPosition: "10px 10px" }}
        className="absolute inset-0 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))] dark:[mask-image:linear-gradient(0deg,rgba(255,255,255,0.1),rgba(255,255,255,0.5))]"
      ></div>
      <div className="relative overflow-auto rounded-xl p-8">
        <div className="flex items-center justify-center">
          <button
            type="button"
            className="inline-flex cursor-not-allowed items-center rounded-md bg-brand-primary-dynamic px-4 py-2 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-brand-primary-dynamic"
            disabled={true}
          >
            <svg
              className="-ml-1 mr-3 h-5 w-5 animate-spin text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            {text}
          </button>
        </div>
      </div>
    </div>
  );
}
